import { TDR } from 'tdr-common';
import config from '../common/config';
import Availability = TDR.Availability;
import { useQuery } from '@tanstack/react-query';

const CACHE_SETTINGS = {
	staleTime: 2 * 60 * 1000, // 2 minutes - timeslots change as reservations are made
	gcTime: 5 * 60 * 1000, // 5 minutes - keep in cache for quick navigation
	refetchOnMount: false, // Don't refetch on component mount if cache is fresh
	refetchOnWindowFocus: false // Don't refetch when user returns to tab
};

export function useTimeslot(tableId: string, dateStr: string, restaurantId: string, timeStr: string, groupSize?: number) {
	const query = useQuery({
		enabled: !!restaurantId && !!tableId && !!dateStr && !!timeStr,
		queryKey: ['timeslot', tableId, dateStr, restaurantId, timeStr, groupSize],
		queryFn: () => getTimeslot({
			tableId,
			dateStr,
			restaurantId,
			timeStr,
			groupSize
		}),
		...CACHE_SETTINGS
	});

	return query;
}

async function getTimeslot(input: Availability.getTimeSlotInput): Promise<Availability.getTimeSlotOutput> {
	const response = await fetch(`${config.apiHost}/getTimeSlot`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(input)
	});

	const responsePayload = await response.json() as Availability.getTimeSlotOutput;
	if (!response.ok) {
		throw response;
	}
	else if (!responsePayload?.success) {
		const { restaurantId, tableId, dateStr, timeStr } = input;
		throw Error(`Could not find timeslot for restaurantId: ${restaurantId}, tableId: ${tableId} dateStr: ${dateStr}, timeStr: ${timeStr}`);
	}

	return responsePayload;
}